import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthPage } from './pages/AuthPage';
import { Dashboard } from './pages/Dashboard';
import { StorefrontPage } from './pages/StorefrontPage';
import { AcceptInvitePage } from './pages/AcceptInvitePage';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import { useAuth } from './hooks/useAuth';

function App() {
  const { profile, loading, isAuthenticated } = useAuth();

  useEffect(() => {
    const path = window.location.pathname;
    const search = window.location.search;

    if (path.includes('/invite/')) {
      const token = path.split('/invite/').pop();
      window.location.href = `${window.location.origin}/#/invite/${token}`;
    }

    if (path.includes('/p/')) {
      const slug = path.split('/p/').pop();
      window.location.href = `${window.location.origin}/#/p/${slug}${search}`;
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-surface flex flex-col items-center justify-center space-y-4">
        <div className="w-12 h-12 border-4 border-ink border-t-transparent rounded-full animate-spin" />
        <p className="label-caps text-ink-muted">Initializing NexSlot...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/p/:slug" element={<StorefrontPage />} />
        <Route path="/invite/:token" element={<AcceptInvitePage />} />

        <Route
          path="/"
          element={
            isAuthenticated && profile ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <AuthPage />
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard profile={profile!} />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
